module.exports = __webpack_public_path__ + "img/63937e6.png";